// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"c02135ce","418":"da5835f6","648":"e6320b3b","961":"3c738a37"}[chunkId] + ".chunk.js";
};